"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = require("react");
const components_1 = require("../components");
const utils_1 = require("../utils");
function createForeignComponentContainer(contextTypes = ['router']) {
    var _a;
    return _a = class ForeignComponentContainer extends React.Component {
            componentDidMount() {
                const node = this.container;
                const ctx = this.context;
                if (node) {
                    const _a = this.props, { render } = _a, rest = tslib_1.__rest(_a, ["render"]);
                    render(node, rest, ctx);
                }
            }
            render() {
                return (React.createElement("div", { ref: node => {
                        this.container = node;
                    } }));
            }
        },
        _a.contextTypes = contextTypes.reduce((ct, key) => {
            // tslint:disable-next-line
            ct[key] = () => null;
            return ct;
        }, {}),
        _a;
}
function wrapReactComponent(Component, stasisOptions, componentOptions) {
    return (props) => (React.createElement(components_1.ArbiterStasis, Object.assign({}, stasisOptions, { renderProps: props }),
        React.createElement(Component, Object.assign({}, props, (componentOptions || {})))));
}
function wrapForeignComponent(render, stasisOptions, componentOptions, contextTypes) {
    const Component = createForeignComponentContainer(contextTypes);
    return (props) => (React.createElement(components_1.ArbiterStasis, Object.assign({}, stasisOptions, { renderProps: props }),
        React.createElement(Component, Object.assign({}, props, (componentOptions || {}), { render: render }))));
}
/**
 * Wraps the provided component (or rendering function) to a React component
 * with automatic stasis usage.
 * @param value The component value to wrap within a stasis.
 * @param options The options to consider.
 * @returns A React component wrapping the value.
 */
function wrapComponent(value, options = {}) {
    const { forwardProps, contextTypes = [] } = options, stasisOptions = tslib_1.__rest(options, ["forwardProps", "contextTypes"]);
    if (value) {
        const argAsReact = value;
        const argAsRender = value;
        const argRender = argAsReact.prototype && argAsReact.prototype.render;
        if (utils_1.isfunc(argRender) || argAsReact.displayName) {
            return wrapReactComponent(argAsReact, stasisOptions, forwardProps);
        }
        return wrapForeignComponent(argAsRender, stasisOptions, forwardProps, contextTypes);
    }
    else {
        console.error('The given value is not a valid component.');
        return wrapForeignComponent(() => { }, stasisOptions, forwardProps, contextTypes);
    }
}
exports.wrapComponent = wrapComponent;
